import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ActionButton from './ActionButton';

const propTypes = {
  actions: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  row: PropTypes.shape({}).isRequired,
};

function CellActions(props) {
  const {
    buttons, index, row, actions,
  } = props;
  return (
    <Fragment>
      {buttons.map((button, indx) => {
        const show = typeof button.show === 'undefined' ? () => true : () => button.show(row);
        return show() ? (
          <ActionButton
            // eslint-disable-next-line react/no-array-index-key
            key={indx}
            show={show}
            label={button.label}
            icon={button.icon}
            color={button.color}
            onClick={() => button.callback(row, actions, index)}
          />
        ) : null;
      })}
    </Fragment>
  );
}

CellActions.propTypes = propTypes;

export default CellActions;
